import { HoursOfServiceTable } from "../HoursOfServiceTable";
import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutHoursOfService extends Layout {
    labelLastNDays: Label;
    labelSummary: Label;
    layoutHoursOfServiceTable: HoursOfServiceTable;
    panelHoursOfService: Panel;
    panelInfo1: Panel;
    panelInfo2: Panel;
    panelInfo3: Panel;
    panelInfo4: Panel;
    sourceDriverHours: DataSource;
    sourceDriverInfo: DataSource;
    textboxAvlDriveHours: Textbox;
    textboxAvlHoursToday: Textbox;
    textboxAvlHoursTomorrow: Textbox;
    textboxAvlOndutyHours: Textbox;
    textboxDutyStatus: Textbox;
    textboxLastUpdate: Textbox;
    textboxName: Textbox;
}
